import { Box, Typography } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import moment from 'moment'

const ChartContainerFile =(props)=>{
    const { data, dateRange } = props;
  
  const getDataArray = () => {
    const arr = [];
     _.map(data, (val, k) =>   arr.push(val.count))
    return arr;
  }
   const series= [{
      name: 'Executed',
      data: getDataArray()
    },
    
  ]

  const getCategories = () => {
    let dates = _.map(data, (val, k) => Number(dateRange) <= 31 ? moment.utc(val.date).format('DD MMM') : val.date)
    if(Number(dateRange) > 31){
      dates = _.sortBy(dates, d => moment(d,'MMM,YYYY'))
    } else {
      dates = _.sortBy(dates, d => moment(d,'DD MMM'))
    }
    return dates;
  }
   const options= {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        // type: 'datetime',
        categories: getCategories()
        // ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm'
        },
      },
      legend: {
        show:true,
          position: 'bottom',
          floating: true,
          // verticalAlign: 'top',
          // align:'right',
          inverseOrder: true,
          // offsetX: 460,
          offsetY: 23,
      },
      chart: {
        toolbar: false
      }
    }
  
    return(
      <Box>
        
        <ReactApexChart options={options} series={series} type="area" height={300} width='100%'/>
      
      </Box>
    );
}

export default ChartContainerFile;